export default __webpack_public_path__ + "static/media/reddit.21345ec2.jpg";